import React from "react";

export default function NotFound() {
    return (
        <div>
            <h2 className="display-6 text-center my-5">NotFund Page.</h2>
        </div>
    )
}
